exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".material-wrap[data-v-e0c420b6]{padding:40px 0 0;border-top:1px solid #e6e6e6}.material-wrap .title[data-v-e0c420b6]{font-size:22px;line-height:24px;margin-bottom:23px;font-weight:700}", ""]);

// exports
